import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, Container, Toolbar } from '@mui/material';
import { ThemeProvider } from './theme/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { InventoryProvider } from './contexts/InventoryContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { ScanProvider } from './contexts/ScanContext';
import { NotificationScanProvider } from './contexts/NotificationScanContext';
import { AppHeader } from './components/layout/AppHeader';
import { AppSidebar } from './components/layout/AppSidebar';
import { NotificationProvider } from './components/common/NotificationSystem';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Callback } from './components/auth/Callback';
import { RuleEditorEnhanced } from './components/RuleEditorEnhanced';
import { Overview } from './components/Overview';
import { Inventory } from './components/Inventory';
import { AwsAccounts } from './components/AwsAccounts';
import { NamingConventions } from './components/NamingConventions';
import { Settings } from './components/Settings';
import SupportButton from './components/SupportButton';



const drawerWidth = 280;

function App() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <AuthProvider>
      <ThemeProvider>
        <NotificationProvider>
          <InventoryProvider>
            <ConfigProvider>
              <ScanProvider>
                <NotificationScanProvider>
          <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
              <Route path="/callback" element={<Callback />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Box sx={{ display: 'flex' }}>
                      <AppSidebar open={mobileOpen} onClose={() => setMobileOpen(false)} drawerWidth={drawerWidth} />
                      <AppHeader onMenuToggle={handleDrawerToggle} drawerWidth={drawerWidth} />
                      
                      <Box
                        component="main"
                        sx={{
                          flexGrow: 1,
                          p: 3,
                          width: { sm: `calc(100% - ${drawerWidth}px)` },
                          bgcolor: 'background.default',
                          minHeight: '100vh',
                        }}
                      >
                        <Toolbar />
                        <Container maxWidth="xl" sx={{ py: 2 }}>
                          <Routes>
                            <Route path="/" element={<Overview />} />
                            <Route path="/inventory" element={<Inventory />} />
                            <Route path="/rules" element={<RuleEditorEnhanced onSave={() => {}} />} />
                            <Route path="/aws-accounts" element={<AwsAccounts />} />
                            <Route path="/naming-conventions" element={<NamingConventions />} />
                            <Route path="/settings" element={<Settings />} />
                          </Routes>
                        </Container>
                      </Box>
                    </Box>
                    <SupportButton />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
                </NotificationScanProvider>
              </ScanProvider>
            </ConfigProvider>
          </InventoryProvider>
        </NotificationProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App; 